// Runs `run` a fixed delay after the document's `load` event, so the work
// stays off the critical path of the first paint. Answers a cancel.
export function scheduleAfterLoad(
  run: () => void,
  delayMs: number,
): () => void {
  let timeoutId: number | undefined;

  const schedule = () => {
    timeoutId = window.setTimeout(run, delayMs);
  };

  if (document.readyState === "complete") {
    schedule();
  } else {
    window.addEventListener("load", schedule, { once: true });
  }

  return () => {
    window.removeEventListener("load", schedule);
    if (timeoutId != null) {
      window.clearTimeout(timeoutId);
    }
  };
}
